import * as React from "react";
import { IReportingPeriod } from "../../../model/reporting/ReportingPeriod";
import { Row, Col, Descriptions } from "antd";
import { DateService } from "../../../service/DateService";

const dateFormatter = DateService();
const ReportingPeriodOverview = ({
  reportingPeriod,
  translate
}: {
  reportingPeriod: IReportingPeriod;
  translate: any;
}) => {
  return (
    <div>
      <Row>
        <Col span={12}>
          <Descriptions
            column={1}
            bordered
            size={"small"}
            layout={"horizontal"}
          >
            <Descriptions.Item
              label={translate(
                "reporting_period_overview.reporting_period_type_code"
              )}
            >
              {reportingPeriod.reportingTypeCode}
            </Descriptions.Item>
            <Descriptions.Item
              label={translate("reporting_period_overview.name")}
            >
              {reportingPeriod.name}
            </Descriptions.Item>
            <Descriptions.Item
              label={translate(
                "reporting_period_overview.number_of_reporting_period"
              )}
            >
              {reportingPeriod.numberOfReportingPeriod}
            </Descriptions.Item>
            <Descriptions.Item
              label={translate("reporting_period_overview.status")}
            >
              {reportingPeriod.status}
            </Descriptions.Item>
            <Descriptions.Item
              label={translate("reporting_period_overview.period_from")}
            >
              { reportingPeriod.periodFrom && dateFormatter.formatDate(reportingPeriod.periodFrom)}
            </Descriptions.Item>
            <Descriptions.Item
              label={translate("reporting_period_overview.period_to")}
            >
               { reportingPeriod.periodTo && dateFormatter.formatDate(reportingPeriod.periodTo)}
            </Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>
    </div>
  );
};

export default ReportingPeriodOverview;
